import { withDependencies } from '@wix/thunderbolt-ioc'
import { name } from '../symbols'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { createWorker, destroyWorker, getWorkerId } from '../tpaWorkerCommon'
import type { Experiments, IPropsStore, IStructureAPI } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol, Props, StructureAPI } from '@wix/thunderbolt-symbols'
import type { ITpaWorkerSideEffects } from '@wix/thunderbolt-types'
import type { ITpaSrcBuilder, ITpaContextMapping } from 'feature-tpa-commons'
import { TpaSrcBuilderSymbol, TpaContextMappingSymbol } from 'feature-tpa-commons'

export const TpaWorkerSideEffects = withDependencies(
	[StructureAPI, Props, TpaSrcBuilderSymbol, TpaContextMappingSymbol, ExperimentsSymbol],
	(
		structureApi: IStructureAPI,
		props: IPropsStore,
		tpaSrcBuilder: ITpaSrcBuilder,
		tpaContextMapping: ITpaContextMapping,
		experiments: Experiments
	): IModelUpdatesHandlersImplementor<ITpaWorkerSideEffects> => {
		let tpaWorkersSet = new Set<string>()
		const deprecateAppIdExperimentOn = experiments['specs.thunderbolt.deprecateAppId']
		return {
			featureName: name,
			handlers: {
				handleTpaWorkersChange: (tpaWorkers) => {
					const nextTpaWorkersSet = new Set<string>()

					Object.entries(tpaWorkers).forEach(([appKey, workerData]) => {
						const workerId = getWorkerId(appKey)

						if (!tpaWorkersSet.has(workerId)) {
							const maybeAppDefinitionId = deprecateAppIdExperimentOn
								? {
										appDefinitionId: appKey,
									}
								: {}
							createWorker({
								tpaContextMapping,
								props,
								tpaSrcBuilder,
								structureApi,
								workerId,
								...workerData,
								...maybeAppDefinitionId,
							})
						}

						nextTpaWorkersSet.add(workerId)
					})

					for (const workerId of tpaWorkersSet) {
						if (!nextTpaWorkersSet.has(workerId)) {
							destroyWorker({
								tpaContextMapping,
								props,
								structureApi,
								workerId,
							})
						}
					}
					tpaWorkersSet = nextTpaWorkersSet
				},
			},
		}
	}
)
